import wnd from './window';
import getDocument from './document';
import scrollbarWidth from './scrollbar-width';

export default function windowViewport(element) {
    var win = wnd(element);
    var document = getDocument(element);
    var result = {
        height: win.innerHeight,
        width: win.innerWidth
    };

    if (document.scrollHeight - document.clientHeight > 0) {
        result.width -= scrollbarWidth();
    }

    return result;
}



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/window-viewport.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/window-viewport.js
// module chunks = 3